import { render } from "./SeriesCard.vue?vue&type=template&id=befeccca"
import script from "./SeriesCard.vue?vue&type=script&lang=js"
export * from "./SeriesCard.vue?vue&type=script&lang=js"

import "./SeriesCard.vue?vue&type=style&index=0&id=befeccca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__